<template>
  <q-card flat bordered>
    <q-dialog
      v-if="showDeleteTagDialog && toDeleteTag"
      v-model="showDeleteTagDialog"
      persistent
      transition-duration="100"
    >
      <q-card>
        <q-card-section>
          <div class="text-h6">Delete Tag</div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <div>
            Are you sure you want to delete the tag:
            <span class="text-bold">{{ toDeleteTag }}</span
            >?
          </div>
          <q-banner class="q-mt-md bg-blue-1 text-blue-8" icon="info" dense rounded>
            It will not remove it from existing reports but will prevent new reports from using it.
            You can always change the tags on individual reports to new and different ones later.
          </q-banner>
        </q-card-section>
        <q-separator />
        <q-card-actions align="right">
          <q-btn v-close-popup flat label="Cancel" no-caps unelevated />
          <q-btn
            v-close-popup
            no-caps
            unelevated
            label="Delete"
            color="red"
            @click="removeTag(toDeleteTag)"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-card-section class="flex justify-between">
      <div>
        <div class="text-h6 q-my-auto">Report Tags</div>
        <div style="font-size: 12px">
          Add tags to your property reports to help organize and categorize them.
        </div>
      </div>
      <div class="q-my-auto">
        <q-btn
          v-if="newTag"
          color="primary"
          no-caps
          unelevated
          icon="add"
          label="Add Tag"
          @click="addTag"
        />
      </div>
    </q-card-section>
    <q-separator />
    <q-card-section class="q-col-gutter-md row">
      <div class="col-12">
        <div class="text-bold q-mb-sm">Current Tags</div>
        <q-chip
          v-for="tag in availableReportTags"
          :key="tag"
          :removable="!defaultReportTags.includes(tag)"
          :color="$q.dark.isActive ? 'grey-9' : 'grey-4'"
          @remove="toDeleteTag = tag"
        >
          {{ tag }}
          <span v-if="defaultReportTags.includes(tag)" class="text-weight-light q-ml-sm"
            >(default)</span
          >
        </q-chip>
      </div>
      <div class="col-12">
        <div class="text-bold q-mb-sm">Add Tag</div>
        <q-input
          v-model="newTag"
          filled
          placeholder="Enter a new tag name"
          clearable
          @keyup.enter="addTag"
        >
          <template #prepend>
            <q-icon name="label" />
          </template>
        </q-input>
      </div>
    </q-card-section>
  </q-card>
</template>

<script lang="ts">
import { useUserStore } from '@/stores/user'

export default {
  name: 'ReportTags',
  data() {
    return {
      defaultReportTags: ['Active', 'Portfolio', 'Archived', 'Research'],
      newTag: null as string | null,
      toDeleteTag: null as string | null
    }
  },
  computed: {
    showDeleteTagDialog: {
      get() {
        return this.toDeleteTag !== null
      },
      set(value: boolean) {
        if (!value) {
          this.toDeleteTag = null
        }
      }
    },
    availableReportTags() {
      return useUserStore().availableReportTags
    },
    organization() {
      return useUserStore().organization
    }
  },
  methods: {
    addTag() {
      if (this.newTag) {
        this.updateOrganizationReportTags([...this.availableReportTags, this.newTag])
        this.newTag = null
      }
    },
    removeTag(tag: string) {
      this.updateOrganizationReportTags(this.availableReportTags.filter((_) => _ !== tag))
    },
    updateOrganizationReportTags(newTags: string[]) {
      if (this.organization?.id) {
        useUserStore().updateOrganization(this.organization.id, {
          display_name: this.organization.display_name,
          owner_user_id: this.organization.owner_user_id,
          admin_user_ids: this.organization.admin_user_ids,
          connection_id: this.organization.connection_id,
          logo_url: this.organization.logo_url,
          report_tags: newTags,
          use_security_groups: this.organization.use_security_groups,
          sections: this.organization.sections,
          columns: this.organization.columns
        })
      }
    }
  }
}
</script>
